import angular from 'angular';

import {} from './account.less';

module.exports = angular.module('market.routes.humans.account', [
  require('angular-ui-router')
])
.config(function($stateProvider) {
  $stateProvider.state('humans.account', {
    url: '/account',
    template: require('./account.jade')(),
    controllerAs: 'accountCtrl',
    controller: class {
      constructor($rootScope, $window) {
        this.session = $rootScope.session;

        if (!this.session.human || !this.session.human.id) {
          $window.location.href = '/login';
        }
      }

      remoteSignOut() {
        this.pending = true;
        this.session.human.$remoteSignOut().then(() => {
          this.pending = false;
          this.success = true;
          // Reload the page now that you signed out
          location.reload();
        }).catch((response) => {
          this.pending = false;
          if (response.status === 401) {
            this.errors = { current_password: true };
          } else if (response.status === 422) {
            this.errors = response.data;
          }
        });
      }

      update() {
        this.pending = true;
        delete this.errors;
        delete this.success;

        this.session.human.$update().then(() => {
          this.pending = false;
          this.success = true;
        }).catch((response) => {
          this.pending = false;

          if (response.status === 401) {
            this.errors = { current_password: true };
          } else if (response.status === 422) {
            this.errors = response.data;
          }
        });
      }
    }
  });
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/market/routes/humans/account.js
 **/